module.exports = __webpack_public_path__ + "images/emoji/leo.6ce7b9fb046cc4747f95.png";